const hasClaimForCompany = (user: any, companyId: string, claim: string): boolean => {
    if (!user) {
        return false
    }

    if (user.isSuperAdmin) {
        return true
    }

    if (!user.roles || user.roles.length === 0 || !companyId || !claim) {
        return false
    }

    const role = user.roles.find((role: any) => role.companyId === companyId)
    return role?.claim === claim
}

export default hasClaimForCompany
